module.exports = __webpack_public_path__ + "img/drawer_exit.913bd619.svg";